import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAmplitudeExperiment } from '../utils/helpers'

const ExperimentContext = createContext();

const ExperimentProvider = ({ children }) => {
  const [ampTestosteronePriceVariant, setAmpTestosteronePriceVariant] = useState('testosterone_pricing_variation_0')
  const [ampBloodflowPriceVariant, setAmpBloodflowPriceVariant] = useState('bloodflow_pricing_q1_25_variation_0')
  const [ampWeightlossPriceVariant, setAmpWeightlossPriceVariant] = useState('weight_loss_pricing_q1_25_variation_0')
  const [ampFirstInstallmentDiscountVariant, setAmpFirstInstallmentDiscountVariant] = useState('testosterone_first_installment_discount_variation_0')

  useEffect(() => {
    getAmplitudeExperiment('testosterone_first_installment_discount', (variant) => {
      const { value } = variant

      if (value) {
        setAmpFirstInstallmentDiscountVariant(value)
        window._ampFirstInstallmentDiscountVariant = value
        window.analytics.track('ExperimentViewed', {
          experiment_name: 'Testosterone_First_Installment_Discount',
          segment: value
        })
      }
    })

    getAmplitudeExperiment('testosterone_pricing', (variant) => {
      const { value } = variant

      if (value) {
        setAmpTestosteronePriceVariant(value)
        window._ampTestosteronePriceVariant = value
        window.analytics.track('ExperimentViewed', {
          experiment_name: 'Testosterone_Pricing_Experiment_Q1_25',
          segment: value
        })
      }
    })

    getAmplitudeExperiment('bloodflow_pricing_q1_25', (variant) => {
      const { value } = variant
      
      if (value) {
        setAmpBloodflowPriceVariant(value)
        window._ampBloodflowPriceVariant = value
        window.analytics.track('ExperimentViewed', {
          experiment_name: 'BloodFlow_Pricing_Experiment_Q1_25',
          segment: value
        })
      }
    })

    getAmplitudeExperiment('weight_loss_pricing_q1_25', (variant) => {
      const { value } = variant
      
      if (value) {
        setAmpWeightlossPriceVariant(value)
        window._ampWeightlossPriceVariant = value
        window.analytics.track('ExperimentViewed', {
          experiment_name: 'WeightLoss_Pricing_Experiment_Q1_25',
          segment: value
        })
      }
    })
  }, [])

  return (
    <ExperimentContext.Provider value={{ ampTestosteronePriceVariant, ampBloodflowPriceVariant, ampWeightlossPriceVariant, ampFirstInstallmentDiscountVariant }}>
      {children}
    </ExperimentContext.Provider>
  );
};

const useExperimentData = () => {
  return useContext(ExperimentContext)
}

export { ExperimentProvider, useExperimentData }